const pluginExtend = {
    async getProducts() {
        await fetch('data/config.json')
            .then(response => response.json())
            .then(data => {
                let event = new CustomEvent('config_loaded', {detail: data});
                window.dispatchEvent(event);
            });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    ui.init();
    pluginExtend.getProducts();
});